<div class="page-content">
    
    <div>
        
        <h2 style="color: #00669A;">Ingresar paciente</h2>
        
        <h3>Datos Generales:</h3>
        <div class="row">
          <div class="col-md-6">
            <label>Especialidad</label>
            <div class="form-field">
              <mat-select [disabled]="disabledBTN" [(ngModel)]="selected">
                <mat-option *ngFor="let item of clinicsData" [value]="item.code" (click)="chooseStablishment(item.name)">
                {{item.name}}
                </mat-option>
              </mat-select>
            </div>
            
          </div>
          <div class="col-md-6">
              <label>Número de historia clínica</label>
              <div>
                  <input class="form-field" type="text" [disabled]="disabledBTN" [(ngModel)]="clinicHistoryText">
              </div>
          </div>

          <div class="col-md-12">
              <label>Número del paciente</label>
              <div>
                  <input class="form-field" type="text" [disabled]="disabledBTN" [(ngModel)]="patName"> 
              </div>
          </div>
  
        </div>

        <h3>Periodicidad de Formularios para el Paciente:</h3>
        <div class="row">
            <div class="col-md-6 peridiocity-select">
                <input type="radio" [(ngModel)]="periodic" name="periodic" id="normal" value="normal">
                <label for="normal">Normal</label>
            </div>
            <div class="col-md-6 peridiocity-select">
                <input type="radio" (click)="generateCustomForm()" [(ngModel)]="periodic" name="periodic" id="custom" value="customized">
                <label for="custom">Personalizado</label>
            </div>
        </div>

        <div class="row" *ngIf="this.periodic != 'customized' && this.filterFormByIdStablisment.length">
            <div class="col-md-12">
                <table class="periodicity-preview">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Periodicidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let form of this.filterFormByIdStablisment; let i = index">
                            <td class="first-column">{{form.name}}</td>
                            <td>
                              {{form.periodic[0].validatedPeriod ? 'Periódico' : 'Una sola vez'}}
                              <div *ngIf="form.periodic[periodicLevel[this.periodic]].validatedPeriod">
                                <div *ngFor="let period of form.periodic[periodicLevel[this.periodic]].period; let i = index"><b>{{i+1}}.</b> {{period | frequency}}</div>
                              </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row" *ngIf="this.periodic == 'customized' && this.filterFormByIdStablisment.length">
          <div class="col-md-12">
              <table class="periodicity-preview">
                  <thead>
                      <tr>
                          <th>Nombre</th>
                          <th>Periodicidad</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let form of this.filterFormByIdStablisment; let i = index">
                          <td class="first-column">{{form.name}}</td>
                          <td>
                            {{form.periodic[0].validatedPeriod ? 'Periódico' : 'Una sola vez'}}
                            <div *ngIf="form.periodic[0].validatedPeriod">
                              <div class="periodFormField" *ngFor="let periodGroup of customPeriodArray['id-'+form.custf_id].period; let j = index">
                                <input class="form-field" [(ngModel)]="periodGroup.amount" type="number">
                                <div class="form-field select">
                                  <mat-select [(ngModel)]="periodGroup.unit">
                                    <mat-option value="hours">Horas</mat-option>
                                    <mat-option value="days">Días</mat-option>
                                    <mat-option value="months">Meses</mat-option>
                                  </mat-select>
                                </div>
                                <button type="button" mat-icon-button (click)="deletePeriod(j,form.custf_id)"><mat-icon>close</mat-icon></button>
                              </div>
                              <button mat-flat-button type="button" (click)="addPeriod(form.custf_id)"><mat-icon>add</mat-icon> AGREGAR PERIODO</button>
                            </div>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </div>
        
        
        <!-- <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
            <button mat-raised-button style="background: #00669A; color: #fff; " class="btn-block btn-lg m-t-20 m-b-20" type="button" (click)="createUSer()">Grabar</button>
        </div> -->
        <div style="display: flex; justify-content: end;" *ngIf="!msgDone">
          <button *ngIf="btnCreate" mat-raised-button style="background: #00669A; color: #fff;" type="button" (click)="verifyUser()">Continuar</button>
        </div>
    
    
        <!-- <div *ngIf="msgDone" class="card-subtitle" style=" background: rgb(204, 223, 247); border-radius: 2mm; padding: 2%; margin-top: 5%;">
          <div class="footer">
            <p class="text-center" style="color: #5288ec; font-size: 14px;">!Atención!</p>      
          </div>
          Usuario creado satisfactoriamente, las credenciales de acceso fueron enviadas a : {{dataSesion.mail}} y {{mailUserSender}}
        </div>
        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" style="margin-top: 5%;" *ngIf="msgDone">
          <button mat-raised-button style="background: #4EAAD8; color: #fff; " class="btn-block btn-lg m-t-20 m-b-20" type="button" (click)="closeModal()">Cerrar</button>
       </div> -->
        
    </div>    

</div>
